import React,{Component} from 'react';
import './Orders.css';
import NabarClient from '../Components/NabarClient/NabarClient';
import HeaderTool from '../Components/HeaderTool/HeaderTool';
import iconphone from '../../image/iconphone.svg'

import searchicon from '../../image/searchicon.svg'
import {Link} from 'react-router-dom';
import axios from 'axios'
import {LinkAPI} from '../../API/API'
import HandleRes from '../Components/HandleRes/HandleRes';
import Loading from '../Components/Loading/Loading';

var moment = require('moment');

class Orders extends Component{
    constructor(props) {
        super(props);
        this.state = {
            data:[],
            dataorders:[],
            dataordersafterfilter:[],
            isLoading:true,
            search:'',
            status:'',
            collect:-1,
            currentPage: 1,
            ordersPerPage: 8,
            networkError: false,
            errordatamessage: false,
            errordatamessagetext: '',
            hasError: false,
        };
        this.getorders = this.getorders.bind(this);
        this.getorders()
        this.handleClick = this.handleClick.bind(this);
        this.handlefilterstauts = this.handlefilterstauts.bind(this);

           
        
        }
        getorders=()=>{
            const Token =localStorage.getItem("userToken")

            axios.get(`${LinkAPI}/api/businessowner/orders`,{
                headers:{
                  Authorization:`${Token}`
                }
              }).then(res =>{
                this.setState({
                    data: res.data.orders.reverse(),
                    dataorders: res.data.orders.reverse(),
                    dataordersafterfilter: res.data.orders.reverse(),
                    isLoading:false,

                  })
                  }).catch(error=>{
                    if (!error.response) {
                        this.setState({
                            networkError: true
                        })
                    } else if (error.response.status === 402) {
                        localStorage.removeItem("userToken")
                        window.location.replace("/SignIn");
                    } else if (error.response.data.message) {
                        this.setState({
                            errordatamessage: true,
                            errordatamessagetext: error.response.data.message
                        })
                    } else {
                        this.setState({
                            hasError: true,
                        })
                    } 
                  })
        }
        handleClick(event) {
            this.setState({
              currentPage: Number(event.target.value)
            });
          }
         
        handleChange = event => {
            this.setState({
                [event.target.name]  : event.target.value
            });
        };
        handlefilterstauts = event => {
            const {value} =event.target
            this.setState({
                status  : value
            },()=>{this.filterselect()});
                 
        };
        filterselectDate=event =>{
            if(event.target.value===moment().format('L')){
                let  selectFilter = this.state.data.filter(order=>
                    moment(order.pickupDate).format('L')==moment().format('L')
                )
                this.setState({
                    dataorders: selectFilter,
                    currentPage: 1,

                },()=>{this.filterselect()});
            }else if(event.target.value===moment().add(1, 'days').format('L')){
                let  selectFilter = this.state.dataorders.filter(order=>
                      moment(order.pickupDate).format('L')==moment().add(1, 'days').format('L')

                )
                this.setState({
                    dataorders: selectFilter,
                    currentPage: 1,
                },()=>{this.filterselect()});
            }else{
                this.setState({
                    dataorders: this.state.data,
                    currentPage: 1,
                },()=>{this.filterselect()});
            }
        }
        filterselect=() =>{
            if(this.state.status==="draft"){
                let  selectFilter = this.state.dataorders.filter(order=>
                    order.status===0
                )
                this.setState({
                    dataordersafterfilter: selectFilter,
                    currentPage: 1,

                });
            }else if(this.state.status==="ongoing"){
                let  selectFilter = this.state.dataorders.filter(order=>
                    order.status<8&& order.status!==0
                )
                this.setState({
                    dataordersafterfilter: selectFilter,
                    currentPage: 1,
                });
            }else if(this.state.status==="delivered"){
                let  selectFilter = this.state.dataorders.filter(order=>
                    order.status===7
                )
                this.setState({
                    dataordersafterfilter: selectFilter,
                    currentPage: 1,
                });
            }else if(this.state.status==="failed"){
                let  selectFilter = this.state.dataorders.filter(order=>
                    order.status===8&&order.failedstatus===1
                )
                this.setState({
                    dataordersafterfilter: selectFilter,
                    currentPage: 1,
                });
            }else if(this.state.status==="canceled"){
                let  selectFilter = this.state.dataorders.filter(order=>
                    order.status===9
                )
                this.setState({
                    dataordersafterfilter: selectFilter,
                    currentPage: 1,
                });
            }else{
                this.setState({
                    dataordersafterfilter: this.state.dataorders,
                    currentPage: 1,
                });
            }
        }
       
        changecollect=()=>{
            if(this.state.collect===-1){
                this.setState({
                    collect:0
                  });
            }else{
                this.setState({
                    collect:-1
                  });
            }
        }
    render(){
        document.title ="Kayn | Orders"; 
        document.getElementsByTagName("META")[1].content="Kayn Orders";
        document.documentElement.lang = 'en';

        const handle_state=[['draft','ongoing','ongoing','ongoing','ongoing','ongoing','ongoing','delivered','failed','canceled'],
                            ['failed','failed','failed','failed','failed','failed','failed','failed','failed','canceled'],
                            ['trash','trash','trash','trash','trash','trash','trash','trash','trash','canceled'],
                            ['draft','ongoing','ongoing','ongoing','ongoing','ongoing','ongoing','delivered','failed','canceled'],
                            ['draft','ongoing','ongoing','ongoing','ongoing','ongoing','ongoing','delivered','failed','canceled'],
                            ['draft','ongoing','ongoing','ongoing','ongoing','ongoing','ongoing','delivered','failed','canceled'],
                            
    ]

    let  dataordersFilter = this.state.dataordersafterfilter.filter(order=>
        order.amount>this.state.collect
    )
        let  filteredContantsname = dataordersFilter.filter(
            (contact)=>{
                return contact.reciver.name.toLowerCase().indexOf(this.state.search.toLowerCase())!==-1;
            }
        )
        let  filteredContantsphone = dataordersFilter.filter(
            (contact)=>{
                return contact.reciver.phone.toLowerCase().indexOf(this.state.search.toLowerCase())!==-1;
            }
        )
        let  filteredContantsordernumber = dataordersFilter.filter(
            (contact)=>{
                return contact.ordernumber.toString().indexOf(this.state.search)!==-1;
            }
        )
       
        
        // let filteredContants = filteredContantsname.concat(filteredContantsphone);
        let filteredContants = [...new Set([...filteredContantsordernumber,...filteredContantsphone,...filteredContantsname])]
        const {  currentPage, ordersPerPage } = this.state;
        // Logic for displaying current todos
        const indexOfLastorders = currentPage * ordersPerPage;
        const indexOfFirstorders = indexOfLastorders - ordersPerPage;
        const currentdataorders = filteredContants.slice(indexOfFirstorders, indexOfLastorders);
        const renderdataorders = currentdataorders.map((x, i) => {
          return        <tr key={i}>
          <td className="">
          <Link to={"OrderDetail/"+x.ordernumber}>  {x.ordernumber}</Link></td>
          <td><Link to={"OrderDetail/"+x.ordernumber}>{x.reciver.name}</Link></td>
          <td>{x.dropoffLocation.address_name}</td>
          <td>{x.amount}</td>
          <td><img className="mx-1 iconphone" src={iconphone} alt="iconphone" />{x.reciver.phone}</td>
          <td className="text-center"><span className={"badge-pill "+handle_state[x.failedstatus][x.status]}>{handle_state[x.failedstatus][x.status]}</span></td>
      </tr>
        });

        // Logic for displaying page numbers
        const pageNumbers = [];
        for (let i = 1; i <= Math.ceil(filteredContants.length / ordersPerPage); i++) {
          pageNumbers.push(i);
        }
        const renderPageNumbers = pageNumbers.map(number => {
            return ( <option key={number} value={number} > {number} </option> );
          });
        return(
            <div className="AppEN container-fluid px-0">
                    <div className="row   mx-0">
                        <div className="col-md-1 px-0 ">
                        <NabarClient/>
                        </div> 
                        <div className="Orders client col-md-11 px-lg-5">
                            <HeaderTool/>
                            <h3 className=" fontsize9 my-2">Orders</h3>
                            <div className="filter px-4 row"> 
                                <p className="fontsize11 font-weight-bold mt-2 col-lg-1 col-md-2">View</p>
                                    <div className="col-lg-2 col-md-5">
                                        <div className="form-group  ">
                                            <select id="inputState" className="form-control  badge-pill  text-muted" onClick={this.filterselectDate}>
                                                <option value="all">Date</option>
                                                <option value="all">ALL</option>
                                                <option value={moment().format('L')}>Today</option>
                                                <option value={moment().add(1, 'days').format('L')}>Tomorrow</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-lg-2 col-md-5">
                                        <div className="form-group  ">
                                            <select id="inputState" onChange={this.handlefilterstauts} className="form-control  badge-pill  text-muted">
                                                <option defaultValue>STATUS </option> 
                                                <option value="draft">draft</option>
                                                <option value="ongoing">ongoing</option>
                                                <option value="delivered">delivered</option>
                                                <option value="failed">failed</option>
                                                <option value="canceled">canceled</option>
                                            </select>
                                        </div>
                                    </div>
                                <div className="col-lg-2 col-md-4">
                                    <div className="form-group">
                                        <div className="form-check text-center mt-2">
                                            <input className="form-check-input" type="checkbox"id="invalidCheck2" onChange={this.changecollect}  />
                                            <label className="form-check-label text-muted" htmlFor="invalidCheck2">
                                                COLLECT CASH
                                                </label>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-8 px-5">
                                <div className="form-group has-search  mx-auto">
                                    <input type="text" className="form-control badge-pill" placeholder="search" value={this.state.search} name="search" onChange={this.handleChange}/>
                                    <img className="ml-2 mt--10 searchiconorders" src={searchicon} alt="search "/>

                                </div>
                                </div>
                            </div>
                        
                        <div className="allorder   shadow">
                            <div className="row p-3 ">
                           <p className="col-md-6 mt-3 fontsize4">All Orders</p>
                            
                            </div>
                            
                                {(this.state.isLoading?                    
                                <Loading/>
                                :                            
                                <table className="table  table-bordered bg-white">
                                <thead className="thead-light fontsize12 text-muted">
                                    <tr>
                                        <th scope="col ">
                                            ORDER ID</th>
                                        <th scope="col">CLIENT</th>
                                        <th scope="col">CITY</th>
                                        <th scope="col">CASH</th>
                                        <th scope="col">PHONE CLIENT</th>
                                        <th scope="col">STATUS</th>

                                    </tr>
                                </thead>
                                <tbody className="fontsize11">
                                
                               { (renderdataorders.length!==0?renderdataorders:
                                 <tr >
                                 <td className="">No order yet</td>
                                 <td >..</td>
                                 <td>..</td>
                                 <td>..</td>
                                 <td>..</td>
                                 <td>..</td>
                             </tr>
                                )}
                                </tbody>
                            </table>
                                )}

                               
                            <div className="row px-4">
                            <div className="col-4 mr-auto p-2 bd-highlight">
                                    <p>Total: {filteredContants.length} order</p>
                                </div>
                                <div className="px-lg-5 p-2 bd-highligh">
                                        <div className="form-group  ">
                                            <select onChange={this.handleClick} value={this.state.currentPage}id="inputState" className=" px-5 form-control  badge-pill  text-muted">
                                            {(renderPageNumbers.length===0?<option value="1"> 1 </option>:renderPageNumbers)}
                                            </select>
                                        </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {(this.state.networkError ? <HandleRes title="You are currently offline." stylecss="alert-danger" /> : '')}
                {(this.state.errordatamessage ? <HandleRes title={this.state.errordatamessagetext} stylecss="alert-danger" /> : '')}
                {(this.state.hasError ? <HandleRes title="sorry there was a problem with your request" stylecss="alert-danger" /> : '')}

            </div>
        )
    }
}
export default Orders;